<template>
    <div class="page-content margin-bottom-30">
        <div class="center-text own-title margin-bottom-20">
            My Success Roadmap
        </div>
        <div class="content card round-medium" :style="loadBg">
            <div class="top-bar" :style="loadBar"></div>
            <div class="content-title padding-5 margin-top-20">
                <div class="roadmap-back-wrapper ipad-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0">
                        <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                    </router-link>
                </div>
                <div class="roadmap-back-wrapper mobile-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0 ">
                        <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                    </router-link>
                </div>
                <div class="roadmap-title-wrapper">
                    The Memory Lane
                </div>
                <div class="clear"></div>
            </div>
            <div class="responsive-iframe">
                <video width="90%" controls onloadedmetadata="this.muted = true" playsinline autoplay muted loop>
                    <source :src="'images/mpower-new/my_success_roadmap/memory_lane/video/memory_lane.mp4'" type="video/mp4">
                </video>
            </div>
        </div>
        <RoadmapNav />
    </div>
</template>
<style scoped>
.mobile-display .mandatory{
    text-align: left;
    padding-left: 10px;
    color:#6b867f;
}
.ipad-display .mandatory{
    text-align: left;
    padding-left: 160px;
    color:#6b867f;
}
.center-image{
  display: flex !important;
  justify-content: center;
}
</style>
<script>
import RoadmapNav from '@/components/RoadmapNav.vue'
export default {
    name: 'Agent_journey_normal',
    computed: {
        loadBg(){
            return {
                'backgroundImage': 'url(\'images/mpower/roadmap/blank_bg.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        },
        loadBar() {
            return {
                'background': '#FEE47B'
            }
        }
    },
    components: {
        RoadmapNav
    },
    mounted(){
        window.scrollTo(0,0);
    }
}
</script>
